import React, { Fragment, useState } from "react";
import { useSelector } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import Input from "../../inputs/inputs";
import Button from "../../buttons/buttons";
import Location from "../../includes/location";
import LocationSearch from "../../includes/locationSearch";
import Warning from "../../../assets/images/icons/warning-circle.svg";
//images
import CLOSE from "../../../assets/images/icons/close.svg";

export function AddGuestAddressModal(props) {
  const { handleChange, data, setData, setIsContinueClicked } = props;

  const { filter, filtering } = useSelector((state) => state.publicServiceArea);
  const { settings } = useSelector((state) => state.application);
  const useGooglePlaces = settings?.google_places_status === "available";

  //This is used to set location if google places is active
  const handleSelectLocation = (place) => {
    setIsContinueClicked(false);
    setData((prev) => ({
      ...prev,
      address: place.address,
      country: place.country,
      state: place.state,
      city: place.city,
      latitude: place.lat,
      longitude: place.lng,
      zip: place.postalCode,
    }));
  };

  function handleRegion(e) {
    const { name, value } = e.target;
    setData((data) => ({ ...data, [name]: fromJson(value).name }));
  }

  //This is used to get the list of region data ie: country, city and states
  const [locationId, setLocationId] = React.useState({
    country_id: "",
    state_id: "",
    city_id: "",
  });
  const [locationList, setLocationList] = React.useState({
    countryList: [],
    stateList: [],
    cityList: [],
  });
  const [locationLoader, setLocationLoader] = useState(false);
  const toJson = (value) => JSON.stringify(value);
  const fromJson = (value) => JSON.parse(value);

  const handleSubmit = async () => {
    setIsContinueClicked(false);
    props.onClose();
  };

  return (
    <div data-test="addressModal">
      <Transition show={props.show} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={props.onClose}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-center sm:items-center justify-center min-h-full p-4 sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative w-[600px] bg-white dark:bg-[#121212] rounded-3xl px-4 pt-5 pb-4 max-h-[90vh] h-full overflow-scroll shadow-xl transform transition-all sm:my-10 sm:max-w-lg sm:w-full  sm:p-8">
                  <div className="sm:block absolute top-1 sm:top-3 right-4 pt-4 pr-4">
                    <button
                      type="button"
                      className="bg-[#ffeae5] rounded-3xl p-2 sm:p-3 outline-none"
                      onClick={props.onClose}
                    >
                      <span className="sr-only">Close</span>
                      <img
                        src={CLOSE}
                        alt="close"
                        className=" w-3 h-3 sm:w-4 sm:h-4"
                      />
                    </button>
                  </div>
                  <div className="sm:flex sm:justify-center">
                    <div className="sm:mt-2">
                      <Dialog.Title
                        as="h3"
                        className="text-xl font-medium text-black dark:text-white"
                      >
                        Contact & Delivery Details
                      </Dialog.Title>
                      <p className="dark:text-[#BCBCBC] mt-2">
                        Please complete your contact information and delivery
                        address
                      </p>
                    </div>
                  </div>
                  <div className="mt-5 sm:mt-4">
                    <div className="mt-4 border-b-2 "></div>
                    <div className="mt-8">
                      <div className="mb-6">
                        <div>
                          <label
                            htmlFor="name"
                            className="block text-sm font-medium"
                          >
                            Name
                          </label>
                          <div className="mt-2">
                            <input
                              type="text"
                              name="name"
                              id="name"
                              className="mt-2 block pl-3 pr-10 w-full text-base bg-[#FFFFFF] dark:bg-transparent focus:ring-2 focus:ring-red-600 focus:border-red-600 focus:outline-none sm:text-sm h-[40px] px-4 py-2 mb-4 border border-gray-300 "
                              placeholder="Enter your name"
                              defaultValue={data?.name}
                              onChange={(e) => handleChange(e)}
                            />
                          </div>
                        </div>
                        <div className="mt-4 sm:mt-0">
                          <label
                            htmlFor="email"
                            className="block text-sm font-medium"
                          >
                            Email
                          </label>
                          <div className="mt-2">
                            <input
                              type="email"
                              name="email"
                              id="email"
                              className="mt-2 block pl-3 pr-10 w-full text-base bg-[#FFFFFF] dark:bg-transparent focus:ring-2 focus:ring-red-600 focus:border-red-600 focus:outline-none sm:text-sm h-[40px] px-4 py-2 mb-4 border border-gray-300 "
                              placeholder="Enter your email"
                              value={data?.email}
                              onChange={(e) => handleChange(e)}
                            />
                          </div>
                        </div>
                        <div>
                          <label
                            htmlFor="phone"
                            className="block text-sm font-medium"
                          >
                            Phone
                          </label>
                          <div className="mt-2">
                            <input
                              type="number"
                              name="phone"
                              id="phone"
                              className="mt-2 block pl-3 pr-10 w-full text-base bg-[#FFFFFF] dark:bg-transparent focus:ring-2 focus:ring-red-600 focus:border-red-600 focus:outline-none sm:text-sm h-[40px] px-4 py-2 mb-4 border border-gray-300 "
                              placeholder="Enter phone number e.g: 08123456789"
                              defaultValue={data?.phone}
                              onChange={(e) => handleChange(e)}
                            />
                          </div>
                        </div>

                        {/* Delivery details */}
                        <div className="mt-8 mb-8">
                          <h2 className="font-bold text-xl mb-2">
                            Delivery Details
                          </h2>
                          <div className="flex justify-between items-center gap-4">
                            <div className="flex items-center gap-2">
                              <img
                                src={Warning}
                                className="w-[18px] h-[18px]"
                                alt="warning"
                              />
                              <p className="text-sm text-[#9CA3AF]">
                                Kindly fill in address details if this order
                                must be delivered to your current location.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div>
                          {/* Google Places or Manual Address */}
                          <>
                            {useGooglePlaces ? (
                              <div className="mb-4">
                                <LocationSearch
                                  onPlaceSelect={handleSelectLocation}
                                  searchLocationTitle={
                                    "Search Delivery Address*"
                                  }
                                />
                              </div>
                            ) : (
                              <div>
                                <label
                                  htmlFor="phone"
                                  className="block text-sm font-medium"
                                >
                                  Street Address
                                </label>
                                <div className="mt-2">
                                  <input
                                    type="text"
                                    name="address"
                                    id="address"
                                    className="mt-2 block pl-3 pr-10 w-full text-base bg-[#FFFFFF] dark:bg-transparent focus:ring-2 focus:ring-red-600 focus:border-red-600 focus:outline-none sm:text-sm h-[40px] px-4 py-2 mb-4 border border-gray-300 "
                                    placeholder="Enter street address"
                                    defaultValue={data?.address}
                                    onChange={(e) => handleChange(e)}
                                  />
                                </div>
                              </div>
                            )}
                          </>
                          <div>
                            <label
                              htmlFor=""
                              className="block text-sm font-medium"
                            >
                              Add Delivery Details (optional)
                            </label>
                            <div className="mt-2">
                              <input
                                type="text"
                                name="description"
                                id="description"
                                className="mt-2 block pl-3 pr-10 w-full text-base bg-[#FFFFFF] dark:bg-transparent focus:ring-2 focus:ring-red-600 focus:border-red-600 focus:outline-none sm:text-sm h-[40px] px-4 py-2 mb-4 border border-gray-300 "
                                placeholder="E.g door or apartment number..."
                                defaultValue={data?.description}
                                onChange={(e) => handleChange(e)}
                              />
                            </div>
                          </div>

                          <Location
                            country_id={locationId.country_id}
                            state_id={locationId.state_id}
                            city_id={locationId.city_id}
                            loadingLocation={(value) => {
                              setLocationLoader(value);
                            }}
                            countryList={(value) => {
                              setLocationList({
                                ...locationList,
                                countryList: value,
                              });
                            }}
                            stateList={(value) => {
                              setLocationList({
                                ...locationList,
                                stateList: value,
                              });
                            }}
                            cityList={(value) => {
                              setLocationList({
                                ...locationList,
                                cityList: value,
                              });
                            }}
                          />

                          <div className={useGooglePlaces ? "hidden" : ""}>
                            <div className="mt-6">
                              <Input.Select
                                title={"Select Country"}
                                name="country"
                                id="country"
                                className="w-full border border-[#E4E4F3] focus-within:border-primary focus:border-primary focus:ring-0 sm:text-sm"
                                htmlFor={"country"}
                                onChange={(e) => {
                                  setLocationId({
                                    ...locationId,
                                    country_id: fromJson(e.target.value).id,
                                  });
                                  handleRegion(e);
                                }}
                              >
                                <option>Select Country</option>
                                {locationLoader ? (
                                  <option>Loading...</option>
                                ) : (
                                  locationList?.countryList &&
                                  locationList?.countryList?.length > 0 &&
                                  locationList?.countryList?.map(
                                    (item, key) => {
                                      return (
                                        <option
                                          key={key}
                                          value={toJson({
                                            name: item.name,
                                            id: item.id,
                                          })}
                                        >
                                          {item.name}
                                        </option>
                                      );
                                    }
                                  )
                                )}
                              </Input.Select>
                            </div>
                            <div className="mt-6">
                              <Input.Select
                                title={"Select State"}
                                name="state"
                                id="state"
                                className="w-full border border-[#E4E4F3] focus-within:border-primary focus:border-primary focus:ring-0 sm:text-sm"
                                htmlFor={"state"}
                                onChange={(e) => {
                                  setLocationId({
                                    ...locationId,
                                    state_id: fromJson(e.target.value).id,
                                  });
                                  handleRegion(e);
                                }}
                              >
                                <option>Select State</option>
                                {locationLoader ? (
                                  <option>Loading...</option>
                                ) : (
                                  locationList?.stateList &&
                                  locationList?.stateList?.length > 0 &&
                                  locationList?.stateList?.map((item, key) => {
                                    return (
                                      <option
                                        key={key}
                                        value={toJson({
                                          name: item.name,
                                          id: item.id,
                                        })}
                                      >
                                        {item.name}
                                      </option>
                                    );
                                  })
                                )}
                              </Input.Select>
                            </div>
                            <div className="mt-6">
                              <Input.Select
                                title={"Select City"}
                                name="city"
                                id="city"
                                className="w-full border border-[#E4E4F3] focus-within:border-primary focus:border-primary focus:ring-0 sm:text-sm"
                                htmlFor={"city"}
                                onChange={(e) => {
                                  setLocationId({
                                    ...locationId,
                                    city_id: fromJson(e.target.value).id,
                                  });
                                  handleRegion(e);
                                }}
                              >
                                <option>Select City</option>
                                {locationLoader ? (
                                  <option>Loading...</option>
                                ) : (
                                  locationList?.cityList &&
                                  locationList?.cityList?.length > 0 &&
                                  locationList?.cityList?.map((item, key) => {
                                    return (
                                      <option
                                        key={key}
                                        value={toJson({
                                          name: item.name,
                                          id: item.id,
                                        })}
                                      >
                                        {item.name}
                                      </option>
                                    );
                                  })
                                )}
                              </Input.Select>
                            </div>
                            <div className="mt-6">
                              <Input.Select
                                title={"Service Area"}
                                name="service_area_id"
                                id="service_area_id"
                                className="w-full border border-[#E4E4F3] focus-within:border-primary focus:border-primary focus:ring-0 sm:text-sm"
                                htmlFor={"service_area_id"}
                                onChange={handleChange}
                                disabled={useGooglePlaces}
                              >
                                <option>Select service area</option>
                                {filtering
                                  ? "Loading..."
                                  : filter?.length > 0 &&
                                    filter?.map((item, i) => {
                                      return (
                                        <option key={i} value={item?.id}>
                                          {item.area}
                                        </option>
                                      );
                                    })}
                              </Input.Select>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Continue Button */}
                      <div className="mt-6">
                        <Button.Primary
                          title="Continue"
                          className="w-full h-[48px] px-4"
                          disabled={
                            !data?.name ||
                            !data?.email ||
                            !data?.phone ||
                            !data?.address ||
                            !data?.city ||
                            !data?.state ||
                            !data?.country
                          }
                          onClick={() => handleSubmit()}
                        />
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
}
